import { CommunityMembership } from "../../models";

export interface MembershipListResult {
  members: CommunityMembership[];
  memberCount: { total: number; currentPage: number };
  pages: { total: number; currentPage: number };
}
